import React from "react";
import EmployeeHiresGenericSkeleton from "./EmployeeHiresGenericSkeleton";

function EmployeeHiresDetailSkeleton() {
  return (
    <>
      <EmployeeHiresGenericSkeleton />
    </>
  );
}

export default EmployeeHiresDetailSkeleton;
